export enum PlayingType {
  play = 'play',
  playing = 'playing',
  paused = 'paused',
  hovered = 'hovered',
  focused = 'focused',
  update = 'update',
  leave = 'leave',
  blur = 'blur'
}

export enum LazyLoadType {
  ondemand = 'ondemand',
  progressive = 'progressive'
}

export enum SwipeDirection {
  left = 'left',
  right = 'right',
  up = 'up',
  down = 'down',
  vertical = 'vertical'
}

export enum SlideNavigation {
  next = 'next',
  previous = 'previous'
}

export enum WidthDetection {
  auto = 'auto',
  manual = 'manual'
}
